import AdminLayout from "../../../components/admin/layout/AdminLayout";
import AdminSetting from "../../../components/admin/setting/AdminSetting";
import React from "react";

//어드민 설정 페이지
const AdminSettingPage: React.FC = () => {
    return (
        <AdminLayout>
            {/*어드민 설정*/}
            <AdminSetting/>
        </AdminLayout>
    )
}
export default AdminSettingPage;